<template>
  <div :class="className">
    <svg-icon :name="props.icon" />
    <p class="p">{{ props.msg }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  color: {
    type: String,
    default: 'default'
  },
  msg: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: 'alert'
  }
});

const className = computed(() => {
  return ['msg-box ', `color-${props.color} `];
});
</script>
<style lang="scss">
.msg-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 2px;
  font-size: 12px;

  .p {
    flex: 1;
    line-height: 18px;
    padding: 4px 0;
  }
  .svg-icon {
    width: 12px;
    height: 12px;
  }

  &.color-default {
    background-color: var(--Yellow-10);
    color: var(--Text-primary);

    .svg-icon {
      fill: var(--Text-secondary);
    }
  }

  &.color-default {
    background-color: var(--Yellow-10);
    color: var(--Text-primary);

    .svg-icon {
      fill: var(--Text-secondary);
    }
  }

  &.color-red {
    background-color: var(--Red-10);
    color: var(--Text-primary);

    .svg-icon {
      fill: var(--Text-secondary);
    }
  }
}
</style>
